import { shopPrefix } from '../../config';
import { http } from '../axios';
import { RemoveBulkByLineItemKeysRequest } from '../selection-list/removeBulkFromListByLineItemKeys';
import { IncludeProductSelection } from '../../shared/product-selection/ProductSelectionTypes';
import { convertLineItemKeysToDto } from '../../shared/utils/convertLineItemKey';
import { globalErrorResponse } from '../../shared/notification/actions';
import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { ListContentSource, SOURCE_CART } from '../../store/constants';
import { showNotification } from '../../shared/notification/toastNotification';
import { TFunction } from 'i18next';

const url = `${shopPrefix}/v2/shoppingcart/bulk/lineItemKeys/remove`;

export const removeProductsFromCartByLineItemKeys = (body: RemoveBulkByLineItemKeysRequest, t: TFunction) => {
    return http.put<void>(url, body).then(res => res.data);
};

export function removeFromCart({
    productSelection,
    onSuccess,
    source,
    t
}: {
    productSelection: IncludeProductSelection;
    onSuccess?: () => void;
    source: ListContentSource;
    t: TFunction;
}) {
    if (source !== SOURCE_CART) {
        return;
    }
    const body: RemoveBulkByLineItemKeysRequest = {
        lineItemKeys: convertLineItemKeysToDto(productSelection.included)
    };

    removeProductsFromCartByLineItemKeys(body, t)
        .then(() => {
            showNotification(t('notifications.removeFromCart.success'));
            invalidateCartSummaryQuery().then();
            invalidateCartGroupedItems().then();
            invalidateShoppingCartProducts().then();
            invalidateCartAggregations().then();
            if (onSuccess) {
                onSuccess();
            }
        })
        .catch(error => {
            globalErrorResponse(error);
            return Promise.reject();
        });
}
